export const workAllocationHeaders = [
    {key : "client", value : "Agency"},
    {key : "mr_number", value : "MR Number"},
    {key : "patient_name", value : "Patient Name"},
    {key : "arrived_date", value : "Arrived Date"},
    {key : "payor_type_hchb", value : "Payor Type (As per HCHB)"},
    {key : "assessment_type", value : "Assessment Type"},
    {key : "status", value : "Status"},
    {key : "priority", value : "Priority"},
    {key : "coder", value : "Coder"},
    {key : "production_tl", value : "Production TL"},
]


export const workAllocationImportErrors = [
    {key : "warning", value : "Warning"},
]